import RestService from "../services/rest.service";

export const getKpiFormList = (type,emp_id) => (dispatch) => {
  let endPoint = type && type !== "" ? `app/kpi/kpi_form?type=${type}` : `app/kpi/kpi_form`
  endPoint += emp_id && emp_id !== "" ? `&employee_id=${emp_id}` : ``
  return new Promise((resolve, reject) => {
    RestService.get(endPoint).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAchievementSummary = (serial, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(data !== null && data !== undefined ? `app/kpi/achievement?serial=${serial}&employee_id=${data}` : `app/kpi/achievement?serial=${serial}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAchievementList = (serial, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(data !== null && data !== undefined ? `app/kpi/achievement/list?serial=${serial}&employee_id=${data}` : `app/kpi/achievement/list?serial=${serial}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAchievementAdd = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/add?form=${serial}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postAchievementAdd = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let reqBody = {
      form_evaluate_id: data.formEvaluateID,
      name: data.name,
      detail: data.description,
      start_date: data.startDate,
      end_date: data.endDate,
      metric: data.metric,
      target_value: data.metricValue,
      target_unit: data.metricUnit,
      target_unit_custom: data.metricUnitCustom,
      target_condition: data.metricCondition,
      is_link: data.isLink,
      goals: data.selectedGoals,
      competencies: data.selectedCompetencies,
      cycle_id: data.cycle
    }
    RestService.post(`app/kpi/achievement/add`, reqBody).then(
      (response) => {
        // let data = response.data.data
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAchievementEdit = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/${serial}/edit`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postAchievementEdit = (data, serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let reqBody = {
      form_evaluate_id: data.formEvaluateID,
      name: data.name,
      detail: data.description,
      start_date: data.startDate,
      end_date: data.endDate,
      metric: data.metric,
      target_value: data.metricValue,
      target_unit: data.metricUnit,
      target_unit_custom: data.metricUnitCustom,
      target_condition: data.metricCondition,
      is_link: data.isLink,
      goals: data.selectedGoals,
      competencies: data.selectedCompetencies,
      cycle_id: data.cycle
    }
    RestService.post(`app/kpi/achievement/${serial}/edit`, reqBody).then(
      (response) => {
        // let data = response.data.data
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const deleteAchievement = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/kpi/achievement/${serial}`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAchievementFiles = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/${serial}/files`).then(
      (response) => {
        let resp = response.data.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const deleteFileAchievement = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/kpi/achievement/file/${serial}`).then(
      (response) => {
        let resp = response.data.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postUploadFile = (serial, file) => (dispatch) => {
  let data = new FormData();
  for (let index = 0; index <= file.length - 1; index++) {
    data.append("file", file[index]);
  }
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/achievement/${serial}/files`, data).then(
      (response) => {
        let resp = response.data.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getConfigUpload = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/config/upload/kpi_achievement_file`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getFileDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/file/${serial}`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};
